import { createAsyncThunk } from "@reduxjs/toolkit";
import { IDeleteApiResponse } from "../../utils/api.types";
import axios from "../../utils/axios";

import {
    ICustomerDetails,
    ICustomersList,
    CustomerFetch
} from "../../utils/customer.types";

/**
 * Fetch Customers async thunk.
*/
export const fetchCustomers = createAsyncThunk(
    'account/fetchCustomers',
    async (accountId: string): Promise<ICustomersList> => {
        const response = await axios.get(`api/v1/customers/${accountId}`);

        return response.data.customers;
    }
);

export const fetchCustomersWithFilters = createAsyncThunk(
    'account/fetchCustomersWithFilters',
    async ({accountId, params} : CustomerFetch): Promise<ICustomersList> => {
        console.log("params == ", params);
        let queryParam = (params) ? `${params}`: ''
        const response = await axios.get(`/api/v1/customers/${accountId}/search?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch Customer by user id async thunk.
*/
export const fetchCustomersById = createAsyncThunk(
    'account/fetchCustomersById',
    async (id: string): Promise<ICustomerDetails> => {
        const response = await axios.get(`api/v1/customers/single/${id}`);
        return response.data;
    }
);

/**
 * Fetch Customer by user id async thunk.
*/
export const updateServicesCustomerById = createAsyncThunk(
    'account/updateServicesCustomerById',
    async (updatePayload: any): Promise<ICustomerDetails> => {
        const response = await axios.put(`api/v1/customers/single/update-agreed-services`, updatePayload);
        return response.data;
    }
);








